export const MoveObjectToFirstPlace = (arr, defaultItem) => {
  // Fix added after switching to express-api for fetching overlays
  if (!defaultItem) {
    return arr;
  }

  if (arr.length > 0)
    return [defaultItem, ...arr.filter(item => item.id !== defaultItem?.id)];
  else return [];
};
